import { Outlet } from "react-router"
import { Sidebar, BottomNav } from "./Sidebar.js"
import "./layout.css"

/** Renders around every protected route (RequireAuth wraps this in the
 *  router). Sidebar on desktop, bottom tab bar on mobile — same nav
 *  items, driven by the same useNavItems() so they never drift apart.
 *  Topbar.tsx fue eliminado (Fase B del TODO de UI/UX): su contenido
 *  (nombre de la app, toggle de tema, usuario, logout) vive ahora en el
 *  header/footer del propio Sidebar. Ver _deprecated/Topbar.tsx.old. */
export function AppShell() {
  return (
    <div className="mc-shell">
      <Sidebar />
      <div className="mc-shell__main">
        <main className="mc-shell__content" style={{ flex: 1 }}>
          <Outlet />
        </main>
      </div>
      <BottomNav />
    </div>
  )
}
